import { render, staticRenderFns } from "./run-form-item.vue?vue&type=template&id=bf269198&scoped=true&"
import script from "./run-form-item.vue?vue&type=script&lang=ts&"
export * from "./run-form-item.vue?vue&type=script&lang=ts&"
import style0 from "./run-form-item.vue?vue&type=style&index=0&id=bf269198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf269198",
  null
  
)

export default component.exports